import '@ids/style-card';

import type { Action, Content } from '../../global-types/Content';
import LinkItem from './LinkItem';

type LinkItemCollectionProps = {
  content: Content;
  viewId: number | undefined;
  dispatchActionEvent: (action: Action) => void;
};

function LinkItemCollection({ content, viewId, dispatchActionEvent }: LinkItemCollectionProps) {
  const view = viewId ? content.contentViews?.find((cv) => cv.contentViewId === viewId) : undefined;
  if (view === undefined) return null;

  const linkItemsData = (content.content ?? []).filter((item) => item.contentType === 'linkItem');
  const collectionTitle = view.viewElements.texts?.[0];

  return (
    <div className="if flex flex-column mb-16">
      {collectionTitle && (
        <h2 className={`if typography heading ${collectionTitle?.size}`}>{collectionTitle?.value}</h2>
      )}
      {linkItemsData.length > 0 && (
        <ul className="if grid ">
          {linkItemsData.map((item) => (
            <div className="if col-4 md-col-6 lg-col-4 size-w-100p">
              <LinkItem key={item.id} content={item} dispatchActionEvent={dispatchActionEvent} />
            </div>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LinkItemCollection;
